// This is a COPY of downread/shared/src/db/capabilities.ts. To modify, edit the original and then run downread/bin/build-shared.sh
/**
 * Capabilities
 * Capabilities (permissions) are encoded in a string. Each character represents a capability.
 *
 * The format is:
 * "1" - the version of the encoding
 * "o"/"s"/"a"/"-" - owner ("o") of downread, superuser ("s"), agent ("a"), or a user ("-")
 *
 * Tiers (highest → lowest):
 *   Owner ("o")    - Singleton root account. Only Owner can promote other users to Owner
 *                    (see api/handler/users.ts, newUserType == Owner check). Implies Superuser.
 *   Superuser ("s") - Full admin: gates the /admin/* endpoints (via validateAdminRequest in
 *                    api/handler/admin-common.ts), bypasses subscription checks on feeds, and
 *                    can access all catalogs. Implies Agent.
 *   Agent ("a")    - Limited operational role: can only mutate feedStatus and userStatus via
 *                    /api/agent/* (see api/handler/agent.ts). Does NOT get /admin/* access.
 *                    Intended for automation (e.g. the downread-control agent CLI) where you
 *                    want hygiene/triage powers without granting full admin.
 *   User ("-")     - Regular user, baseline. No elevated access.
 *
 * The is*() checks below are minimum-tier predicates: isAgent() is true for Agent, Superuser,
 * and Owner; isSuperuser() is true for Superuser and Owner; isOwner() is true only for Owner.
 */
export function checkCapabilities(capabilities: string) {
    return capabilities.length == 2 && capabilities[0] == '1';
}
export function isUser(capabilities?: string) {
    return !!capabilities && capabilities[1] == '-';
}
export function isOwner(capabilities?: string) {
    return !!capabilities && capabilities[1] == 'o';
}
export function isAgent(capabilities?: string) {
    return !!capabilities && (capabilities[1] == 'a' || isSuperuser(capabilities));
}
export function isSuperuser(capabilities?: string) {
    return !!capabilities && (capabilities[1] == 's' || isOwner(capabilities));
}

export enum UserType {
    Owner = 'o',
    Superuser = 's',
    Agent = 'a',
    User = '-',
}

export function createCapabilities(type: UserType) {
    return `1${type}`;
}

export function getUserType(capabilities: string): UserType {
    return capabilities[1] as UserType;
}
